/**
 * Phase 6 Plan 02 — useInspectionPhotos (HIST-5.7, D-135).
 *
 * Lazy GET /api/admin/inspections/{id}/photos (PM-only). Enabled only when
 * the parent row is expanded. Invalidated on inspection.photo_uploaded SSE
 * events (D-137) so the placeholder→thumbnail flip is live.
 */
import { useQuery } from "@tanstack/react-query";
import { apiGet, ApiError } from "../../api/client";
import {
  INSPECTION_PHOTOS_KEY,
  type InspectionPhotosResponse,
} from "../../api/inspections";

export function useInspectionPhotos(inspectionId: number, enabled: boolean) {
  return useQuery<InspectionPhotosResponse, ApiError>({
    queryKey: INSPECTION_PHOTOS_KEY(inspectionId),
    queryFn: () =>
      apiGet<InspectionPhotosResponse>(
        `/api/admin/inspections/${inspectionId}/photos`,
      ),
    enabled: enabled && inspectionId > 0,
    staleTime: 30_000,
  });
}
